import {displayUuid} from "@ui-kit/utils/static/string-format-util";
import {
  DisplayFunction,
  DisplayOrder,
  Hidden,
  String, TableDisplayedDefault
} from "@ui-webkit/components/crud-item/crud-item-decorator";


export class LeasePos {
  @String("Domain Prefix")
  @DisplayOrder(3)
  @TableDisplayedDefault
  domainPrefix: string;

  @String("Access Token")
  accessToken: string;

  @String("Outlet ID")
  @DisplayOrder(4)
  @TableDisplayedDefault
  @DisplayFunction(displayUuid)
  outletId: string;

  @String("Payment Source")
  @DisplayOrder(5)
  @TableDisplayedDefault
  paymentSourceName: string;

  @String("Payment Type")
  @DisplayOrder(6)
  @TableDisplayedDefault
  paymentTypeName: string;

  @Hidden
  loginUrl: string;

  @Hidden
  loginUsername: string;

  @Hidden
  loginPassword: string;

  @String('Retailer ID')
  @DisplayOrder(1)
  @TableDisplayedDefault
  retailerId?: number;

  @String('Display Name')
  @DisplayOrder(2)
  // @TableDisplayedDefault
  displayName?: string;

  @String('POS ID')
  @DisplayFunction(displayUuid)
  posAccountUuid?: string;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.domainPrefix = obj.domainPrefix;
    this.outletId = obj.outletId;
    this.accessToken = obj.accessToken;
    this.retailerId = obj.retailerId;
    this.displayName = obj.displayName;
    this.paymentSourceName = obj.paymentSourceName;
    this.paymentTypeName = obj.paymentTypeName;
    this.posAccountUuid = obj.posAccountUuid;
    this.loginPassword = obj.loginPassword;
    this.loginUsername = obj.loginUsername;
    this.loginUrl = obj.loginUrl;
  }
}
